export const OSCWaves = ["sine", "sawtooth", "triangle", "square"];
export const LFOWaves = ["sine", "sawtooth", "triangle", "square"];
export const FILTERTypes = [
  { type: "lowpass", rolloff: -12 },
  { type: "lowpass", rolloff: -24 },
  { type: "bandpass", rolloff: -12 },
  { type: "bandpass", rolloff: -24 },
  { type: "highpass", rolloff: -12 },
  { type: "highpass", rolloff: -24 },
  { type: "allpass" }
];
